import { OmitStrict } from '@tanium/coreui-utils';
import { Icon } from '@tanium/react-graphics';
import { NavSectionLeaf } from '@tanium/react-workbench';

export enum SideNavType {
  Home = 'home',
  Cloud = 'cloud',
  Artifacts = 'artifacts',
}

export interface SideNavItem {
  type: SideNavType;
  icon?: string | Icon;
  href: string;
  label: string;
  disabled?: boolean;
}

export type SectionLeaf = OmitStrict<NavSectionLeaf, 'route'>;

export interface ActiveRowInfo {
  index: number;
  element?: HTMLElement;
}

export type ActiveRows = [ActiveRowInfo, ActiveRowInfo];
